import { withInstall } from '../../../utils/with-install'
import DirectionalLight from './DirectionalLight.vue'

export const ElAmapLocaDirectionalLight = withInstall(DirectionalLight)
export default ElAmapLocaDirectionalLight
